import { styled } from '@mui/material/styles'
import { Tabs } from '@mui/material'

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  '& .MuiButtonBase-root': {
    minHeight: '3rem',
  },
  '& .MuiTab-textColorPrimary': {
    color: theme.palette.text.primary,
  },
  '& .MuiTabs-flexContainer': {
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .Mui-selected': {
    borderBottom: '2px solid',
    color: theme.palette.primary.main,
  },
}))
